import Prace from './Prace';
export default Prace;